import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { isEmpty, timeout } from 'rxjs/operators';

import { TraslateService } from '../traslate.service';
export var single = [
  {
    "name": "Score Economie",
    "value": 70.65
  },
  {
    "name": "Inactivité moy",
    "value": 100
  },
  {
    "name": "Effectif",
    "value": 18
  }
];





@Component({
  selector: 'app-test',
  templateUrl: './test.component.html',
  styleUrls: ['./test.component.scss']
})


export class TestComponent implements OnInit {
  single: any[];
  view: any[] = [800, 1000];
  min:number = 0;
  max:number = 100;
  legend: boolean = true;
  bigSegments:number =15
  legendPosition: string = 'below';

  colorScheme = {
    domain: ['#5AA454', '#E44D25', '#CFC0BB' ]
  };

/*Graph */


chartOptions: any;
chartOptions2: any;
chartOptions3: any;
chartOptions16: any;
xValues: any;
series1:any = [];
ff:any =null
series2: any= [];
series3: any= [];
series4: any= [];
fff: any= [];
vv: any;
  gaugeValueFormatting: any;

   constructor(private http: HttpClient,private traslateService:TraslateService,private router: Router ) {


    Object.assign(this, { single });
    this.series1=[];
    this.traslateService.obs.subscribe((response)=>{this.traslateService.maptoAtelier(response,this.series1);
      console.log(this.series1);
    } );

    this.series2=[];
    this.traslateService.obs.subscribe((response)=>{this.traslateService.maptoAtelier2(response,this.series2 ,this.series3 ,this.series4);
     console.log('length'+ this.series1.length)
      console.log(this.series2[0] ,this.series3 ,this.series4);
      this.getchrt1(this.series2,this.series3 ,this.series4)
      this.getchrt2(this.series2,this.series3 ,this.series4)

      this.getChrt()
      this.getScore2(this.series2[0])


    } );





   }



  ngOnInit(): void {

    this.gaugeValueFormatting = (value) => {
      return 'Score et moy et effectif'
    };

  }

  chnge(){

    var chnge = 6000
    this.getScore2(chnge)
  }
  chnge2(){
    var chnge = 4000
    this.getScore2(chnge)
  }

  getScore2(e){
    this.chartOptions16 = {
      series: [
        {
          name: "Distance moyenne",
          data: [e]
        },

      ],
      chart: {
        type: "bar",
        height: 100,
        stacked: true,
        dropShadow: {
          enabled: true,
          blur: 1,
          opacity: 0.25
        }
      },
      plotOptions: {
        bar: {
          horizontal: true,
          barHeight: "100%"
        }
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        width: 2
      },
      title: {
        text: "Compare Sales Strategy"
      },
      xaxis: {
        categories: ['Distance moyenne'],
        min: 0,
        max: 146, tooltip: {
          enabled: false
        }
      },
      yaxis: {
        title: {
          text: undefined
        }
      },
      tooltip: {
        shared: false,
        y: {
          formatter: function(val) {
            return val + "Km";
          }
        }
      },
      fill: {
        type: "pattern",
        opacity: 1
      },
      states: {
        hover: {
          filter: {
            type: "none"
          }
        }
      },
      legend: {
        position: "right",
        offsetY: 40
      }
    };



  }



  onSelect(data): void {
    console.log('Item clicked', JSON.parse(JSON.stringify(data)));
  }

  onActivate(data): void {
    console.log('Activate', JSON.parse(JSON.stringify(data.value.value)));
    this.gaugeValueFormatting = (value) => {
      return JSON.parse(JSON.stringify(data.value.name))+':'+ JSON.parse(JSON.stringify(data.value.value))
    };


   }

  onDeactivate(data): void {
    console.log('Deactivate', JSON.parse(JSON.stringify(data)));
  }

getchrt1(e ,e1 ,e2){
  this.chartOptions2 = {

    series:  e,
    colors: ['#2E93fA', '#2E93fA', '#2E93fA', '#2E93fA'],

    chart: {
      width: 380,
      type: "donut",
      dropShadow: {
        enabled: true,
        color: "#111",
        top: -1,
        left: 3,
        blur: 3,
        opacity: 0.2
      }
    },
    stroke: {
      width: 0
    },
    plotOptions: {
      pie: {
        startAngle: 0,
        expandOnClick: true,
        offsetX: 0,
        offsetY: 0,
        customScale: 1,
        dataLabels: {
            offset: 0,
            minAngleToShowLabel: 10
        },
        donut: {
          size: '65%',
          background: 'transparent',
          labels: {
            show: true,
            name: {
              show: true,
              fontSize: '80px',
              fontFamily: 'Helvetica, Arial, sans-serif',
              fontWeight: 600,
              color: undefined,
              offsetY: -10,
              formatter: function (val) {
                return val
              }
            },
            value: {
              show: true,
              fontSize: '16px',
              fontFamily: 'Helvetica, Arial, sans-serif',
              fontWeight: 400,
              color: undefined,
              offsetY: 16,
              formatter: function (val) {
                return val +'%'
              }
            },
            total: {
              show: true,
              showAlways: false,
              label: 'Moyenne',
              fontSize: '22px',
              fontFamily: 'Helvetica, Arial, sans-serif',
              fontWeight: 600,
              color: '#373d3f',
              formatter: function (w) {
                return w.globals.seriesTotals.reduce((a, b) => {
                  return a + b
                }, 0)+'%'
              }
            }
          }
        },
      }
    },

    dataLabels: {
      enabled: true,

      dropShadow: {
        enabled: true,
        left: 2,
        top: 2,
        opacity: 0.5
    }
    },

    legend: {
      show: false



    }

    ,

    fill: {
      type: "pattern",
      opacity: 1,
      colors: e2,
      pattern: {
        enabled: true,
        style: e1
      }
    },
    labels: ['Apple', 'Mango', 'Orange', 'Watermelon'],



    states: {
      title:' gfg',
      hover: {
        filter: {
          type: "none"
        }
      }
    },
    theme: {
      palette: "palette2"
    },
    title: {
      text: "Favourite Movie Type"
    },

    tooltip: {
      title: ' ',
      custom: function({ series, seriesIndex, dataPointIndex, w }) {
        return "<div>ljlkjkljkl</div>";
      }
 },

  };

}
getchrt2(e ,e1 ,e2){
  this.chartOptions3 = {

    series:  e,
    colors: ['#2E93fA', '#2E93fA', '#2E93fA', '#2E93fA'],

    chart: {

      width: 380,
      type: "donut",
      dropShadow: {
        enabled: true,
        color: "#111",
        top: -1,
        left: 3,
        blur: 3,
        opacity: 0.2

      },

    },
    stroke: {
      width: 0
    },
    plotOptions: {
      pie: {
        startAngle: 0,
        expandOnClick: true,
        offsetX: 0,
        offsetY: 0,
        customScale: 1,
        dataLabels: {
            offset: 0,
            minAngleToShowLabel: 10
        },
        donut: {
          size: '65%',
          background: 'transparent',
          labels: {
            show: true,
            name: {
              show: true,
              fontSize: '80px',
              fontFamily: 'Helvetica, Arial, sans-serif',
              fontWeight: 600,
              color: undefined,
              offsetY: -10,
              formatter: function (val) {
                return val
              }
            },
            value: {
              show: true,
              fontSize: '16px',
              fontFamily: 'Helvetica, Arial, sans-serif',
              fontWeight: 400,
              color: undefined,
              offsetY: 16,
              formatter: function (val) {
                return val +'%'
              }
            },
            total: {
              show: true,
              showAlways: false,
              label: 'Moyenne',
              fontSize: '22px',
              fontFamily: 'Helvetica, Arial, sans-serif',
              fontWeight: 600,
              color: '#373d3f',
              formatter: function (w) {
                return w.globals.seriesTotals.reduce((a, b) => {
                  return a + b
                }, 0)+'%'
              }
            }
          }
        },
      }
    },

    dataLabels: {
      enabled: true,

      dropShadow: {
        enabled: true,
        left: 2,
        top: 2,
        opacity: 0.5
    }
    },

    legend: {
      show: false



    }

    ,

    fill: {
      type: "pattern",
      opacity: 1,
      colors: e2,
      pattern: {
        enabled: true,
        style: e1
      }
    },
    labels: ['Apple', 'Mango', 'Orange', 'Watermelon'],



    states: {
      title:' gfg',
      hover: {
        filter: {
          type: "none"
        }
      }
    },
    theme: {
      palette: "palette2"
    },
    title: {
      text: "Favourite Movie Type"
    },

    tooltip: {
      title: ' ',
      custom: function({ series, seriesIndex, dataPointIndex, w }) {
        return "<div>ljlkjkljkl</div>";
      }
 }
}

}




getChrt(){
  this.chartOptions =  {

    series: [

      {

        data:  this.series1
      }
    ],
    chart: {
      height: 500,
      width:1500,
      type: "bubble",
      events: {
        dataPointSelection: (event, chartContext, config) => {
            console.log(config.w.config.labels[config.dataPointIndex])

            console.log(config.w.config.series[0].data[config.dataPointIndex])
            this.router.navigate(['./test/'+config.w.config.series[0].data[config.dataPointIndex][3]]);
            location.reload()
          }


        }
    },
    dataLabels: {
      enabled: false
    },
    fill: {
      opacity: 0.7
    },
    title: {
      text: "Relation entre le score de sécurité et d'économie"
    },
    xaxis: {
      tooltip: {
        enabled: false
      },
      min:0,
      max: 100,

      type: "category",
      tickAmount:12,
      title: {
        text: 'Score economie',

    }

    },
    annotations: {
      yaxis: [
        {
          y: 60,
          borderColor: '#00E396',
          label: {
            borderColor: '#00E396',
            style: {
              color: '#fff',
              background: '#00E396'
            },
            text: 'Y-axis annotation on 8800'
          }
        }
      ],
      xaxis: [
        {

          x: 40,
          borderColor: '#775DD0',
          label: {
            borderColor: '#00E396',
            style: {
              color: '#fff',
              background: '#00E396'
            },
            text: 'X-axis annotation - 22 Nov'
          }
        }
      ]
    },
    yaxis: {

      max: 100,
      title: {
        text: 'Score securite',
        rotate: -90,
        offsetX: 0,
        offsetY: 0,
        style: {

            fontSize: '30px',
            fontFamily: 'Helvetica, Arial, sans-serif',
            fontWeight: 600,
            cssClass: 'apexcharts-yaxis-title',
        },
    }
    },

tooltips: {

  enabled: true,
  onDatasetHover: {
    highlightDataSeries: false,
},
  x: {
    show: false,
    formatter:  (values)=> {
      this.xValues=values;
    }
  ,

 },
y: {
  formatter:  (values)=> {
    return '<i class="fas fa-clock ml-2 mr-2"></i> '+values;
  },
},
z: {
  formatter:  (values)=> {
    return '<i class="fas fa-clock ml-2 mr-2"></i> '+this.xValues;
  },
title: 'score economie'

},


}


}

}




clcik1(){
  this.ff ='jkhjk';
}



}
